import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { ButtonModule } from '@components/button/button.module';
import { InfoBannerModule } from '@components/info-banner/info-banner.module';
import { InvestmentMovementListModule } from '@components/investment-movement-list/investment-movement-list.module';
import { AuthGuard } from '@guards/auth.guard';
import { FilterMovementsPage } from './filter-movements.page';

const routes: Routes = [
  {
    path: '',
    component: FilterMovementsPage,
    canActivate: [AuthGuard],
  },
];

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    InvestmentMovementListModule,
    RouterModule.forChild(routes),
    InfoBannerModule,
    ButtonModule,
  ],
  declarations: [FilterMovementsPage],
  exports: [FilterMovementsPage],
})
export class FilterMovementsPageModule {}
